import React, { useRef } from 'react'

import { generateUID } from '@aytm/app/survey/editor/lib/uid'

export function useUniqIDRef(prefix = ''): React.MutableRefObject<string> {
  const idRef = useRef<string>()

  if (null == idRef.current) {
    idRef.current = `${prefix}${generateUID()}`
  }

  return idRef
}

export default function useUniqID(prefix = ''): string {
  const idRef = useUniqIDRef(prefix)

  return idRef.current
}
